import React, { useEffect } from 'react';
import PerforatorAddPhoto from '../images/PerforatorAdd.png';
import PerforatorEditPhoto from '../images/PerforatorEdit.png';
import PerforatorRemoveOnePhoto from '../images/PerforatorRemoveOne.png';
import PerforatorRemoveAllPhoto from '../images/PerforatorRemoveAll.png';
import styled from 'styled-components';

const StyledContainer = styled.div`
width: 100%;
margin: auto;
padding: 10px 0px 10px 0px;
`;

const PerforatorPage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontSize: "18px" }}>
        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Perforator
        </div>
        <div style={{ margin: '10px 0px' }}>
        To add Perforator, right click <strong>Wellbore</strong> node which you want add Perforator to, then click <strong>Add Perforator</strong> menu. In <strong>Add Perforator</strong> dialog, 
        enter Name, Radius, Color, and Positions, then click <strong>OK</strong>.
        </div>
        <div style={{ margin: '10px 0px' }}>
        Positions' data format is Measure Depth Start and Measure Depth End. Each Perforator is in a line. 
        </div>

        <StyledContainer>
            <img src={PerforatorAddPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        To edit perforator, right click perforator node you want to edit, then click <strong>Edit This Perforator</strong> menu.
        </div>

        <StyledContainer>
            <img src={PerforatorEditPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        To remove perforator, right click perforator node you want to remove, then click <strong>Remove This Perforator</strong> menu.
        </div>
        <StyledContainer>
            <img src={PerforatorRemoveOnePhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        To remove all of perforators, right click <strong>Perforators</strong> node, then click <strong>Remove All Perforators</strong> menu.
        </div>
        <StyledContainer>
            <img src={PerforatorRemoveAllPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>
    </div>
  )
}

export default PerforatorPage;